<template>
  <v-dialog v-model="isActive" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <v-card class="content" style="justify-content: space-between;">
      <div class="header">
        <div class="content-header">
          <div @click="close()" class="return-screen">
            <v-icon color="white">mdi-close</v-icon>
          </div>
          <h2>Pesquisar R.S.</h2>
          <div>Atrelar R.S. ao orçamento selecionado</div>
        </div>
        <div class="header-search">
          <v-text-field v-model="term" v-debounce:2s="search" label="Placa, cliente ou veículo..." outlined hide-details clearable></v-text-field>
        </div>
      </div>
      <div class="list-container">
        <LazyList :items="serviceOrders" @load-more="loadMoreData" :has-more-data="hasMoreData">
          <template v-slot:default="{ items }">
            <v-card @click="selectServiceOrder(service)" v-for="service in items" :key="service.id" elevation="0" class="mx-5 mb-5" style="border: 1px solid #c5c5c5">
              <v-card-title class="pa-0">
                <v-list-item two-line class="px-3">
                  <v-list-item-content>
                    <v-list-item-title style="text-transform: capitalize !important">
                      <div v-if="service.client" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 5px">
                        {{ service.client.name }}
                      </div>
                      <div v-else>
                        Cliente não especificado
                      </div>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <div v-if="service.vehicle" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 5px">
                        {{ service.vehicle.description }} {{ service.vehicle.year_model }}
                      </div>
                      <div v-else>
                        Veículo não especificado
                      </div>
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-icon v-if="service.vehicle">
                    <img :src="service.vehicle.vehicle_plate_photo_url" style="height: 37px; margin-top: 10px;">
                  </v-list-item-icon>

                </v-list-item>
              </v-card-title>
              <v-img :src="service.service_order_photos.length > 0 ? getServiceCoverPhoto(service.service_order_photos) : noPhotoImage" class="align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)" height="200px">
                <v-list-item class="px-3 white--text pb-3">
                  {{ service.description }}
                </v-list-item>
              </v-img>
              <v-card-actions class="px-3">
                <div style="font-size: 14px; margin-top: 1px">
                  <v-icon size="20" style="margin-right: 2px; margin-top: -2px">mdi-account-wrench</v-icon> {{ getLastResponsible(service) }}
                </div>
                <v-spacer></v-spacer>
                <v-chip v-if="getServiceStatus(service.status)" :color="getServiceStatus(service.status).color" class="white--text" label>{{ getServiceStatus(service.status).title }}</v-chip>
                <v-chip v-if="service.service_order_evaluations.length > 0" color="warning" class="white--text ml-2 px-2" label><v-icon size="20" class="mr-1">mdi-star</v-icon> {{ getServiceAverage(service.service_order_evaluations[0]) }}</v-chip>
              </v-card-actions>
            </v-card>
          </template>
        </LazyList>

        <div class="loader" v-if="isLoading">
          <v-skeleton-loader
            class="mx-5"
            type="card"
            style="border: 1px solid #c5c5c5"
          ></v-skeleton-loader>
        </div>

        <div v-if="serviceOrders.length === 0" class="no-results">
          Nenhum Relatório de serviço encontrado
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Thumbor from 'thumbor-js-url-builder';
import LazyList from "@/components/Common/LazyList";

export default {
  name: 'ServiceOrderSelector',
  emits: ['close', 'select'],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LazyList,
  },
  data() {
    return {
      term: '',
      serviceOrders: [],
      currentPage: 1,
      itemsPerPage: 10,
      isLoading: false,
      hasMoreData: false,
    };
  },
  computed: {
    service_status_list() {
      return this.$store.getters['General/organization_status_list'];
    },
    isMotorcycle() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'MOTORCYCLE');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    isTractor() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'TRACTOR');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    isTruck() {
      const user = this.$store.getters['Auth/user'];
      if (!user || !user.organization || !user.organization.organization_parameters) return false;
      const param = user.organization.organization_parameters.find((p) => p.code === 'TRUCK');
      return param ? param.value === 'true' || param.value === 'TRUE' || param.value === true : false;
    },
    noPhotoImage() {
      /* eslint-disable global-require */
      if (this.isTractor) return require('@/assets/ads_nophoto_tractor.png');
      if (this.isMotorcycle) return require('@/assets/ads_nophoto_motorcycle.png');
      if (this.isTruck) return require('@/assets/ads_nophoto_truck.png');
      return require('@/assets/ads_nophoto.png');
      /* eslint-enable global-require */
    },
  },
  watch: {
    term() {
      this.currentPage = 1;
      this.serviceOrders = [];
    },
  },
  methods: {
    close() {
      this.$emit('close');

      this.term = '';
      this.serviceOrders = [];
      this.currentPage = 1;
      this.isLoading = false;
    },
    selectServiceOrder(serviceOrder) {
      this.$emit('select', serviceOrder);
      this.close();
    },
    search() {
      if (this.term.length < 3) {
        this.serviceOrders = [];
        this.hasMoreData = false;
        this.currentPage = 1;

        return;
      }

      this.isLoading = true;

      this.getServiceOrders();
    },
    async getServiceOrders() {
      this.isLoading = true;

      this.$http.get('/service_orders', {
        params: {
          term: this.term,
          page: this.currentPage,
          status: '*',
          size: this.itemsPerPage,
        },
      }).then((response) => {
        this.isLoading = false;

        if (this.currentPage === 1) {
          this.serviceOrders = response.data.rows;
        } else {
          this.serviceOrders = this.serviceOrders.concat(response.data.rows);
        }

        this.hasMoreData = response.data.currentPage < response.data.totalPages;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    loadMoreData() {
      if (this.hasMoreData && !this.isLoading) {
        this.currentPage += 1;
        this.search();
      }
    },
    getServiceStatus(statusRef) {
      const status = this.service_status_list.find(( status ) => status.code === statusRef);
      return status;
    },
    getServiceCoverPhoto(photos) {
      const searchPhotoMain = photos.find(photo => photo.tag === 'entry_medias_main')
      const searchPhotoFront = photos.find(photo => photo.tag === 'entry_medias_front')
      const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');
      let returnPhoto = '';
      if (searchPhotoMain || searchPhotoFront) {
        returnPhoto = searchPhotoMain ? thumbor.setImagePath(searchPhotoMain.photo_url).resize(0, 348).buildUrl() : thumbor.setImagePath(searchPhotoFront.photo_url).resize(0, 348).buildUrl()
      } else {
        returnPhoto = thumbor.setImagePath(photos[0].photo_url).resize(0, 348).buildUrl()
      }
      return returnPhoto
    },
    getLastResponsible(serviceOrder) {
      return serviceOrder.service_order_responsibles.length > 0
        ? serviceOrder.service_order_responsibles.slice(-1)[0].user.name.split(' ')[0]
        : serviceOrder.created_by_user.name.split(' ')[0];
    },
    getServiceAverage(evaluation) {
      return ((evaluation.attendance_note + evaluation.indication_note + evaluation.service_note) / 3).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.list-container {
  overflow-y: auto;
  flex-grow: 1;

  .v-list-item {
    width: 100%;
    min-height: 60px;

    .v-list-item__content {
      padding: 5px 0;
    }

    .v-list-item__icon {
      margin: 0px !important;
      padding-top: 2px !important;
    }
  }
}

.no-results {
  margin-top: 20px;
  color: rgba(0, 0, 0, 0.6);
  font-style: italic;
  text-align: center;
}

.header {
  width: 100%;
  z-index: 999;
  border-radius: 0px !important;

  .content-header {
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .return-screen {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }

    .delete {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
      margin-right: 10px;
    }
  }

  .header-search {
    background-color: #F5F5F5;
    padding: 20px;
  }
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

.service-order-list .v-list-item__avatar {
  background-color: #ccc;
  border-radius: 50%;
}
</style>
